class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
        inputCountry: this.querySelector('input[name="country_code"]'),
        inputLanguage: this.querySelector('input[name="locale_code"]'),
        button: this.querySelector('button'),
        form: this.querySelector('form'),
        panel: this.querySelector('.disclosure__list-wrapper'),
    };

    this.form = this.querySelector('form');
    this.country = this.querySelector('[name="country_code"]');
    this.language = this.querySelector('[name="locale_code"]');

    this.geoWrapper = this.querySelector('[data-geo-wrapper]');

    this.backButton = this.querySelector('[data-back]');

    this.externalMarkets = [];
    if (this.dataset.externalMarkets) {
      try {
        this.externalMarkets = JSON.parse(this.dataset.externalMarkets);
      } catch (e) {}
    }
  }

  connectedCallback() {
    this.form?.addEventListener('submit', (event) => {
      this.onSubmit(event);
    });

    this.buildExternalOptions();
    this.bindCountryChange();
    this.checkCountry();
  }

  buildExternalOptions() {
    if (!this.externalMarkets.length) return;

    const countrySelect = this.form?.querySelector('select[name="country_code"]');
    if (!countrySelect) return;

    const grouped = {};
    this.externalMarkets.forEach((market) => {
      const baseCode = market.code.split('-')[0];
      if (!grouped[baseCode]) {
        grouped[baseCode] = { name: market.name.replace(/\s*\(.*\)$/, ''), currency: market.currency, urls: {} };
      }
      const lang = market.hreflang ? market.hreflang.split('-')[0] : 'en';
      grouped[baseCode].urls[lang] = market.url;
    });

    Object.entries(grouped).forEach(([code, data]) => {
      const option = document.createElement('option');
      option.value = `EXTERNAL_${code}`;
      option.textContent = `${data.name} / ${data.currency}`;
      option.dataset.externalUrls = JSON.stringify(data.urls);
      countrySelect.appendChild(option);
    });
  }

  bindCountryChange() {
    const countrySelect = this.form?.querySelector('select[name="country_code"]');
    const langSelect = this.form?.querySelector('select[name="locale_code"]');
    if (!countrySelect || !langSelect) return;

    this._originalLangOptions = Array.from(langSelect.options).map(o => o.cloneNode(true));

    countrySelect.addEventListener('change', () => {
      const selected = countrySelect.options[countrySelect.selectedIndex];
      if (selected.dataset.externalUrls) {
        const urls = JSON.parse(selected.dataset.externalUrls);
        const langs = Object.keys(urls);
        langSelect.innerHTML = '';
        const langLabels = { it: 'Italiano', en: 'English', fr: 'Français', de: 'Deutsch', es: 'Español' };
        langs.forEach((lang, i) => {
          const opt = document.createElement('option');
          opt.value = lang;
          opt.lang = lang;
          opt.dataset.value = lang;
          opt.textContent = langLabels[lang] || lang;
          if (i === 0) opt.selected = true;
          langSelect.appendChild(opt);
        });
      } else {
        langSelect.innerHTML = '';
        this._originalLangOptions.forEach(o => langSelect.appendChild(o.cloneNode(true)));
      }
      langSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  async checkCountry() {
    if (this.getCookie('forceLocalization')) return

    const url = `/browsing_context_suggestions.json`
        + `?country[enabled]=true`
        + `&country[exclude]=${window.Shopify.country}`
        + `&language[enabled]=true`
        + `&language[exclude]=${window.Shopify.locale}`;
    const result = await ( await fetch(url) ).json();

    const navigationCountry = result.detected_values.country
    if (navigationCountry.handle === this.dataset.userCountry)
      return;


    result.suggestions.forEach((suggestion, index) => {
      if (suggestion.parts.country && suggestion.parts.country.confidence < 2) {
        this.country.value = suggestion.parts.country.handle;
      }
      if (suggestion.parts.language && suggestion.parts.language.confidence < 2) {
        this.language.value = suggestion.parts.language.handle;
      }
    });

    const countrySpan = this.querySelector('[data-country]');
    countrySpan.innerText = navigationCountry.name;

    this.geoWrapper.removeAttribute('hidden');
    this.backButton.removeAttribute('hidden');

    this.backButton?.addEventListener('click', () => {
      this.setCookie('forceLocalization', true);
      this.closest('dialog').close();
    });

    publish(PUB_SUB_EVENTS.countryPopupOpen);
  }

  onSubmit(event) {
    event.preventDefault();

    const countrySelect = this.form.querySelector('select[name="country_code"]');
    if (countrySelect) {
      const selectedOption = countrySelect.options[countrySelect.selectedIndex];
      if (selectedOption.dataset.externalUrls) {
        const urls = JSON.parse(selectedOption.dataset.externalUrls);
        const langSelect = this.form.querySelector('select[name="locale_code"]');
        const lang = langSelect ? langSelect.value : document.documentElement.lang?.split('-')[0] || 'en';
        const baseUrl = urls[lang] || Object.values(urls)[0];
        const countryCode = selectedOption.value.replace('EXTERNAL_', '');
        const sep = baseUrl.includes('?') ? '&' : '?';
        window.location.href = `${baseUrl}${sep}country=${countryCode}&locale=${lang}`;
        return;
      }
    }

    this.setCookie('forceLocalization', true);
    this.form.submit();
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(
      value
    )};expires=${date.toUTCString()};path=/`;
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
      return decodeURIComponent(parts.pop().split(";").shift());
    return null;
  }

}
customElements.define('localization-form', LocalizationForm);
